var render = function render(){var _vm=this,_c=_vm._self._c;return _c('core-gamename',{staticClass:"gamelink",attrs:{"game":_vm.gameRef}})
}
var staticRenderFns = []

export { render, staticRenderFns }